import React, { FC, ComponentProps } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Select as JbcSelect, Option } from 'jbc-front/components/presenters/form/Select';

type SelectFieldProps = ComponentProps<typeof JbcSelect> & {
  name: string;
};

export const Select: FC<SelectFieldProps> = ({ options, name, ...selectProps }) => {
  const { control } = useFormContext();

  const { field } = useController({
    name,
    control
  });

  const handleChange = (option: Option) => {
    field.onChange(option.value);
  };

  const handleBlur = () => {
    field.onBlur();
  };

  return (
    <JbcSelect
      {...selectProps}
      options={options}
      onChange={handleChange}
      onBlur={handleBlur}
      value={options.find((option: Option) => option.value === field.value)}
    />
  );
};
